
export default function TableCol({className, children, ...rest}){
    return(
        <div className={`${className} flex items-center py-4 text-md`} {...rest}>
            {children}
        </div>
    )
}